module.exports = __webpack_public_path__ + "static/img/1.44ed2b0d.jpg";